import React, { useState, useEffect } from "react";
import "../components/LandingPage.css";

const LandingPage = () => {
  const collideText = "Collide!";
  const welcomeText = "Welcome";
  const [showLogin, setShowLogin] = useState(false);
  const [showSignUp, setShowSignUp] = useState(false);
  const [showRoleSelection, setShowRoleSelection] = useState(false);
  const [selectedRoles, setSelectedRoles] = useState([]);
  const [showWhyChoose, setShowWhyChoose] = useState(false);

  const roles = [
    { id: "funder", label: "Funder" },
    { id: "volunteer", label: "Volunteer" },
    { id: "innovator", label: "Innovator" },
    { id: "freelancer", label: "Freelancer" },
    { id: "organization", label: "Organization/NGO" },
  ];

  useEffect(() => {
    // Delay the appearance of "Why Choose Collide?" section
    const timer = setTimeout(() => {
      setShowWhyChoose(true);
    }, 5000); // Adjust the delay time as needed (in milliseconds)
    return () => clearTimeout(timer);
  }, []);

  const handleLoginClick = () => {
    setShowLogin(true);
    setShowSignUp(false);
  };

  const handleSignUpClick = () => {
    setShowSignUp(true);
    setShowLogin(false);
    setShowRoleSelection(true);
  };

  const handleRoleSelect = (role) => {
    if (selectedRoles.includes(role)) {
      setSelectedRoles(selectedRoles.filter((r) => r !== role));
    } else {
      setSelectedRoles([...selectedRoles, role]);
    }
  };

  const handleConfirmRoles = () => {
    if (selectedRoles.length > 0) {
      setShowRoleSelection(false);
      setShowSignUp(true);
    } else {
      alert("Please select at least one role before proceeding.");
    }
  };

  const handleCloseModal = () => {
    setShowLogin(false);
    setShowSignUp(false);
    setShowRoleSelection(false);
    setSelectedRoles([]);
  };

  return (
    <div className="full-screen">
      {/* Welcome Text */}
      <div className="welcome-text self-writing">
        {welcomeText.split("").map((letter, index) => (
          <span key={index}>{letter}</span>
        ))}
      </div>

      {/* Collide Text */}
      <div className="glow-text self-writing">
        {collideText.split("").map((letter, index) => (
          <span key={index}>{letter}</span>
        ))}
      </div>

      {/* Buttons */}
      <div className="buttons-container">
        <button className="button" onClick={handleLoginClick}>
          Login
        </button>
        <button className="button" onClick={handleSignUpClick}>
          Sign Up
        </button>
        <button className="explore-button">Explore</button>
      </div>

      {/* Why Choose Collide Section */}
      {showWhyChoose && (
        <div className="cta-section">
          <h2>Join the reaction</h2>
          <ul>
            <li>Connect with funders, volunteers, and innovators.</li>
            <li>Access exclusive resources and mentorships.</li>
            <li>Turn your ideas into reality.</li>
          </ul>
        </div>
      )}

      {/* Role Selection */}
      {showRoleSelection && (
        <div className="role-selection-modal">
          <div className="role-selection">
            <button className="close-button" onClick={handleCloseModal}>
              &times;
            </button>
            <h2>Select Your Role</h2>
            <div className="roles">
              {roles.map((role) => (
                <div
                  key={role.id}
                  className={`role-card ${
                    selectedRoles.includes(role.id) ? "selected" : ""
                  }`}
                  onClick={() => handleRoleSelect(role.id)}
                >
                  {role.label}
                </div>
              ))}
            </div>
            <button
              className="button confirm-button"
              onClick={handleConfirmRoles}
            >
              OK
            </button>
          </div>
        </div>
      )}

      {/* Login Form */}
      {showLogin && (
        <div className="login-modal">
          <div className="login-form">
            <button className="close-button" onClick={handleCloseModal}>
              &times;
            </button>
            <h2>Login</h2>
            <form>
              <div className="form-group">
                <label htmlFor="username">Username</label>
                <input
                  type="text"
                  id="username"
                  placeholder="Enter username"
                  pattern="^[a-zA-Z._]+$"
                  title="Username can only include letters, underscores, and full stops."
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="password">Password</label>
                <div className="password-container">
                  <input
                    type="password"
                    id="password"
                    placeholder="Enter password"
                    minLength="8"
                    required
                  />
                  <button
                    type="button"
                    className="toggle-password"
                    onClick={(e) => {
                      const input = e.target.previousSibling;
                      input.type =
                        input.type === "password" ? "text" : "password";
                    }}
                  >
                    👁
                  </button>
                </div>
              </div>
              <button type="submit" className="button login-button">
                Login
              </button>
            </form>
          </div>
        </div>
      )}

      {/* Sign Up Form */}
      {showSignUp && (
        <div className="login-modal">
          <div className="login-form">
            <button className="close-button" onClick={handleCloseModal}>
              &times;
            </button>
            <h2>Sign Up</h2>
            <form>
              <div className="form-group">
                <label htmlFor="name">Name</label>
                <input
                  type="text"
                  id="name"
                  placeholder="Enter your name"
                  required
                />
              </div>

              {/* Conditionally render surname field */}
              {selectedRoles !== "organization" && (
                <div className="form-group">
                  <label htmlFor="surname">Surname</label>
                  <input
                    type="text"
                    id="surname"
                    placeholder="Enter your surname"
                    required
                  />
                </div>
              )}

              <div className="form-group">
                <label htmlFor="username">Username</label>
                <input
                  type="text"
                  id="username"
                  placeholder="Choose a username"
                  pattern="^[a-zA-Z._]+$"
                  title="Username can only include letters, underscores, and full stops."
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="password">Password</label>
                <div className="password-container">
                  <input
                    type="password"
                    id="password"
                    placeholder="Create a password"
                    minLength="8"
                    required
                  />
                  <button
                    type="button"
                    className="toggle-password"
                    onClick={(e) => {
                      const input = e.target.previousSibling;
                      input.type =
                        input.type === "password" ? "text" : "password";
                    }}
                  >
                    👁
                  </button>
                </div>
              </div>
              <div className="form-group">
                <label htmlFor="confirm-password">Confirm Password</label>
                <input
                  type="password"
                  id="confirm-password"
                  placeholder="Confirm your password"
                  required
                />
              </div>
              <button type="submit" className="button sign-up-button">
                Sign Up
              </button>
            </form>
          </div>
        </div>
      )}

{showWhyChoose && (
<footer className="footer">
  <div className="footer-container">
    {/* Quick Links */}
    <div className="footer-section links">
      <ul>
        <li><a href="#help-center">Help Center</a></li>
        <li><a href="#terms">Terms of Service</a></li>
        <li><a href="#privacy">Privacy Policy</a></li>
        <li><a href="#faq">FAQ</a></li>
      </ul>
    </div>
  </div>
  <div className="footer-bottom">
    <p>&copy; {new Date().getFullYear()} Collide. All rights reserved.</p>
  </div>
</footer>
)}


    </div>
  );
};

export default LandingPage;
